import { FundOptionProps, FundProps } from '@sola/schema/lib/schema.js';
import { decapitalize } from '@sola/utils/string.ts';

import { DonateFrequency } from '../organisms-cms/donate/_logic/donate.types';
import { FundQueryParams } from './query-params';

// @todo - move somewhere search can use it too without recursive import shannanigans

/**
 * Gets the default amount from suggested amounts array.
 * Priority: override from params →  isDefault item → second item (index 1) → fallback value
 */
export const getDefaultAmount = (
  freq: DonateFrequency,
  fund?: FundProps,
  params?: FundQueryParams,
): string => {
  const key = decapitalize(freq) as keyof FundQueryParams;
  const keyDefault = `default${freq}` as keyof FundQueryParams;
  const keyFundFreq = `suggestedAmounts${freq}` as keyof FundProps;

  const paramValues = params?.[key] as number[] | undefined;

  const suggestedAmounts: FundOptionProps[] =
    paramValues?.map((value) => ({ value })) ??
    (fund?.[keyFundFreq] as FundOptionProps[] | undefined) ??
    [];

  const getValue = (item?: FundOptionProps) =>
    item?.value != null ? String(item.value) : undefined;

  return (
    getValue(
      suggestedAmounts.find(
        (item) => item.value === (params?.[keyDefault] as number),
      ),
    ) ??
    getValue(suggestedAmounts.find((item) => item.isDefault)) ??
    getValue(suggestedAmounts[1]) ??
    'other'
  );
};

/**
 * Gets if the freq is enabled
 * Priority: (false) fund not supporting it -> (false) params set to none -> (true) param have values → (true) suggested has values
 */
export const isFrequencyEnabled = (
  freq: DonateFrequency,
  fund?: FundProps,
  params?: FundQueryParams,
): boolean => {
  const key = decapitalize(freq) as keyof FundQueryParams;
  const keyFundFreq = `suggestedAmounts${freq}` as keyof FundProps;

  if (!fund?.availableFrequencies?.includes(freq)) {
    return false;
  }

  const paramValues = params?.[key] as number[] | undefined;
  if (paramValues && paramValues.length === 0) {
    return false;
  }
  if (paramValues?.length) {
    return true;
  }

  const fundValues = fund?.[keyFundFreq] as FundOptionProps[] | undefined;
  if (fundValues?.length) {
    return true;
  }

  return false;
};
